
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/rEditor/rootComps/editorView/bodyStylesSetter.scss.css.virtualfile';
        module.exports = {};